import { render, staticRenderFns } from "./quesInstru7.vue?vue&type=template&id=6b7493f5"
import script from "./quesInstru7.vue?vue&type=script&lang=js"
export * from "./quesInstru7.vue?vue&type=script&lang=js"
import style0 from "./quesInstru7.vue?vue&type=style&index=0&id=6b7493f5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports